import {VALIDATION_PATTERNS} from '../constants/validation.patterns.constants';

export default class ValidationsService {
    constructor() {
		this.customVaidations = {};
    }

    testNamePattern(value) {
        let regEx = new RegExp(VALIDATION_PATTERNS.GENERIC.ALPHANUMERIC_PATTERN);
        return regEx.test(value);
    }

    testNameLength(value, min = 1, max = 33){
        if (!value) return;
        return (value.length > min  && value.length < max)
    }

    testNameExists(value,list) {
	    return _.find(list,v=>v.name === value);
    }

	testCustomNamePattern(value,pattern) {
	    let regEx = new RegExp(pattern);
	    return regEx.test(value);
    }

	defineCustomValidation(validationName, cb) {
		this.customVaidations[validationName] = cb;
    }

    testCustomValidation(validationName,value) {
	    let customValidation =  this.customVaidations[validationName];
    	if(customValidation && typeof customValidation === 'function') {
		    return customValidation(value);
	    } else {
    		console.error(`Validation ${customValidation} not defined`);
    		return false;
	    }
    }
};


ValidationsService.META = {
    name: 'validationsService'
};

ValidationsService.$inject = [];


// WEBPACK FOOTER //
// ./modules/distribution/services/validations.service.js